import { IPortalSystem } from './types';

export const convertSystem = ({
  ...data
}: IPortalSystem<string>): IPortalSystem<Date> => ({
  ...data,
  created_at: new Date(data.created_at),
  updated_at: new Date(data.updated_at),
});
